import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import 'bootstrap/dist/css/bootstrap.min.css';
import './contactPage.css';

const ContactPage = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ message: '', error: false });
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  // Add validation states
  const [validation, setValidation] = useState({
    email: true,
    phone: true
  });

  const clearStatus = () => {
    setStatus({ message: '', error: false });
  };

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Phone validation function
  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phone);
  };

  // Handle email change with validation
  const handleEmailChange = (e) => {
    clearStatus(); // Clear status on input change
    const email = e.target.value;
    setContactForm({ ...contactForm, email });
    setValidation(prev => ({
      ...prev,
      email: validateEmail(email) || email === ''
    }));
  };
  
  const handlePhoneChange = (e) => {
    clearStatus(); // Clear status on input change
    const phone = e.target.value.replace(/\D/g, '').slice(0, 10);
    setContactForm({ ...contactForm, phone });
    setValidation(prev => ({
      ...prev,
      phone: validatePhone(phone) || phone === ''
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields before submission
    const isEmailValid = validateEmail(contactForm.email);
    const isPhoneValid = validatePhone(contactForm.phone);

    setValidation({
      email: isEmailValid,
      phone: isPhoneValid
    });

    // If any validation fails, stop submission
    if (!isEmailValid || !isPhoneValid) {
      setStatus({
        message: 'Please check email and phone number format.',
        error: true
      });
      return;
    }

    setLoading(true);
    setStatus({ message: '', error: false });

    try {
      const templateParams = {
        from_name: contactForm.name,
        from_email: contactForm.email,
        phone: contactForm.phone,
        message: contactForm.message,
      };

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setStatus({
        message: 'Message sent successfully!',
        error: false
      });

      setContactForm({
        name: '',
        email: '',
        phone: '',
        message: ''
      });

    } catch (error) {
      console.error('EmailJS error:', error);
      setStatus({
        message: 'Failed to send message. Please try again.',
        error: true
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-5">
            <h1 className="contact-title">
              Contact Us<span className="title-dot">.</span>
            </h1>
          </div>
        </div>
        
        <div className="row">
          {/* Left Column - Contact Information */}
          <div className="col-lg-5 mb-5 mb-lg-0">
             <div className="store-info">
              <h5 className="mb-4">CORRESPONDENCE ADDRESS</h5>
              <p>SR TOWERS, AXIS BANK BUILDING,</p>
              <p>2ND FLOOR, DURGA NAGAR Y JUNCTION,</p>
              <p>MAILARDEVPALLY, HYDERABAD, TELANGANA-500005.</p>
            </div>
            
            <div className="store-info">
              <h5 className="mb-4">WORKS</h5>
              <p>PLOT NO.124, BEHIND WELSPUN,</p>
              <p>INDUSTRIAL PARK CHANDANVELLY, SHABAD (MDL),</p>
              <p>RANGA REDDY (DIST), HYDERABAD, TELANGANA-501503.</p>
            </div>
            
            <div className="store-info">
              <h5 className="mb-4">Contacts</h5>
              <p>Email: sales@klmpack.com / info@klmpack.com</p>

              <p>Phone: +91 9063427464 / +91 7995004136</p>

            </div>
            
            <div className="social-links-contact-page">
              <a href="#" className="social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          
          {/* Right Column - Contact Form */}
          <div className="col-lg-7">
            <div className="contact-form">
              <div className="form-border form-border-top-right"></div>
              <div className="form-border form-border-bottom-left"></div>
              
              {status.message && (
                <div className={`alert ${status.error ? 'alert-danger' : 'alert-success'} mb-3`}>
                  {status.message}
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                <input
  type="text"
  className="form-control custom-input"
  placeholder="NAME"
  value={contactForm.name}
  onChange={(e) => {
    clearStatus();
    setContactForm({...contactForm, name: e.target.value});
  }}
  required
/>

                </div>
                
                <div className="mb-4">
                  <input
                    type="email"
                    className={`form-control custom-input ${!validation.email ? 'is-invalid' : ''}`}
                    placeholder="EMAIL"
                    value={contactForm.email}
                    onChange={handleEmailChange}
                    required
                  />
                  {!validation.email && (
                    <div className="invalid-feedback">
                      Please enter a valid email address
                    </div>
                  )}
                </div>

                <div className="mb-4">
                  <input
                    type="tel"
                    className={`form-control custom-input ${!validation.phone ? 'is-invalid' : ''}`}
                    placeholder="PHONE"
                    value={contactForm.phone}
                    onChange={handlePhoneChange}
                    required
                  />
                  {!validation.phone && (
                    <div className="invalid-feedback">
                      Please enter a valid 10-digit phone number
                    </div>
                  )}
                </div>
                
                <div className="mb-4">
                <textarea
  className="form-control custom-input custom-textarea"
  placeholder="MESSAGE"
  value={contactForm.message}
  onChange={(e) => {
    clearStatus();
    setContactForm({...contactForm, message: e.target.value});
  }}
  required
></textarea>
                </div>
                
                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={loading}
                >
                  {loading ? 'SENDING...' : 'SEND MESSAGE'}
                </button>
              </form>
            </div>
          </div>
        </div>
        
        <div className="row mt-5">
          <div className="col-12 text-end">
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;